import * as Fmt_bs$SolvuuRoot0 from "./fmt_bs.bs.js";
var Json =
/* alias */
0;
var json_of_fastq = Fmt_bs$SolvuuRoot0.write_fastq;
var json_of_solvuu = Fmt_bs$SolvuuRoot0.write_solvuu;
var json_of_solvuu_type = Fmt_bs$SolvuuRoot0.write_solvuu_type;
var json_of_solvuu_runtime = Fmt_bs$SolvuuRoot0.write_solvuu_runtime;
var json_of_solvuu_eval = Fmt_bs$SolvuuRoot0.write_solvuu_eval;
var json_of_solvuu_fmt = Fmt_bs$SolvuuRoot0.write_solvuu_fmt;
var json_of_csv_column = Fmt_bs$SolvuuRoot0.write_csv_column;
var json_of_csv = Fmt_bs$SolvuuRoot0.write_csv;
var json_of_fasta = Fmt_bs$SolvuuRoot0.write_fasta;
var json_of_gff_version = Fmt_bs$SolvuuRoot0.write_gff_version;
var json_of_biom_version = Fmt_bs$SolvuuRoot0.write_biom_version;
var json_of_t = Fmt_bs$SolvuuRoot0.write_t;
var fastq_of_json = Fmt_bs$SolvuuRoot0.read_fastq;
var solvuu_of_json = Fmt_bs$SolvuuRoot0.read_solvuu;
var solvuu_type_of_json = Fmt_bs$SolvuuRoot0.read_solvuu_type;
var solvuu_runtime_of_json = Fmt_bs$SolvuuRoot0.read_solvuu_runtime;
var solvuu_eval_of_json = Fmt_bs$SolvuuRoot0.read_solvuu_eval;
var solvuu_fmt_of_json = Fmt_bs$SolvuuRoot0.read_solvuu_fmt;
var csv_column_of_json = Fmt_bs$SolvuuRoot0.read_csv_column;
var csv_of_json = Fmt_bs$SolvuuRoot0.read_csv;
var fasta_of_json = Fmt_bs$SolvuuRoot0.read_fasta;
var gff_version_of_json = Fmt_bs$SolvuuRoot0.read_gff_version;
var biom_version_of_json = Fmt_bs$SolvuuRoot0.read_biom_version;
var t_of_json = Fmt_bs$SolvuuRoot0.read_t;
export { Json, json_of_fastq, json_of_solvuu, json_of_solvuu_type, json_of_solvuu_runtime, json_of_solvuu_eval, json_of_solvuu_fmt, json_of_csv_column, json_of_csv, json_of_fasta, json_of_gff_version, json_of_biom_version, json_of_t, fastq_of_json, solvuu_of_json, solvuu_type_of_json, solvuu_runtime_of_json, solvuu_eval_of_json, solvuu_fmt_of_json, csv_column_of_json, csv_of_json, fasta_of_json, gff_version_of_json, biom_version_of_json, t_of_json };
/* Fmt_bs-SolvuuRoot0 Not a pure module */